import { render, staticRenderFns } from "./ArticleMap.vue?vue&type=template&id=b9d5467a&scoped=true&"
import script from "./ArticleMap.vue?vue&type=script&lang=js&"
export * from "./ArticleMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d5467a",
  null
  
)

export default component.exports